import { EMediaQuery, ETree } from 'src/styles/theme/utils/enums';
import { addTransition, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { INGTooltipProps } from './NGTooltip.type';

export const StyledNGTooltipContainer = styled.div<{ isVisible: boolean; tree?: ETree }>`
	${(p) => css`
		position: fixed;
		z-index: 999;

		height: auto;
		width: auto;
		${mq(EMediaQuery.md, `max-width: 80vw; max-height: 40vh;`)}
		${mq(EMediaQuery.sm, `max-width: 70vw;`)}

		max-width: 350px;
		border-radius: ${p.theme.radius.m};

		${addTransition(undefined, 0.2)}

		display: flex;
		justify-content: center;
		align-items: center;

		flex-direction: column;

		&::before {
			content: ' ';
			position: absolute;
			top: -1px;
			left: -1px;
			right: -1px;
			bottom: -1px;
			z-index: -1;

			border-radius: inherit;
			overflow: hidden;

			${() => {
				switch (p.tree) {
					case ETree.solidity:
						return `background-image: linear-gradient(155.3deg, #65AFFF 29.33%, #6C6CBE 50.34%, #65AFFF 70.95%);`;
					case ETree.general:
						return `background-image: linear-gradient(155.3deg, #9F8C6C 29.33%, #ffeecf 50.34%, #9F8C6C 70.95%);`;
					default:
						return `background-image: linear-gradient(155.3deg, #9F8C6C 29.33%, #ffeecf 50.34%, #9F8C6C 70.95%);`;
				}
			}}
		}

		${p.isVisible
			? `
		opacity: 1;
		pointer-events: all;
		transform: translateY(0);
		`
			: `
		opacity: 0;
		pointer-events: none;
		transform: translateY(5px);
		`}
	`}
`;

export const StyledNGTooltip = styled.div<INGTooltipProps>`
	${(p) => css`
		border-radius: inherit;
		padding: ${p.theme.spacing['4xs']};
		background-color: ${p.theme.colors.charcoal};
		box-shadow: 0px 4px 4px ${p.theme.colors.black + '50'}, inset 0px 0px 12px 9px #00000050;

		flex: 1;
		overflow-y: auto;
	`}
`;
